<template>
    
    <div class="studio-booking">

        <div class="step-wrapper">
            <div class="spinner-border text-primary" role="status" v-if="loading">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="step">
                <a href="javascript:void(0)" class="prev" v-if="step> 1" @click="onStepPrev()">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                </a>
                {{ step }}/2
            </div>
        </div>

        <div class="row">

            <div class="col-sm-12">

                <VueSlickCarousel v-bind="slicksettings" ref="carousel">

                    <div class="slide">

                        <div v-if="selectedService">

                            <!--länge {{ Object.keys(availableSlots).length }} {{ availableSlots }}-->

                            <h5>1. Tag und Uhrzeit auswählen</h5>

                            <div class="mb-2">
                                <Select2 v-model="selectedCalendar" :options="availableSlots.calendars" @change="onSelectedCalendar()" :settings="{ minimumResultsForSearch: 100, placeholder: 'Alle Kalender' }" />
                            </div>

                            <div v-if="availableSlots.availableDates && availableSlots.availableDates.length == 0">
                                <div class="alert alert-danger" role="alert">
                                  Leider wurden keine passenden Buchungstermine gefunden.<br />Bitte wählen Sie einen anderen Kalender.
                                </div>
                                <p class="text-muted"></p>
                            </div>
                            
                            <div v-else>

                                <div class="form-group">
                                    <vc-date-picker v-model="selectedDate" :value="null" :min-date='attributes.min_date' is-inline is-expanded title-position="left" :available-dates='attributes.available_dates' @dayclick='dayClicked' />
                                </div>

                                <p>Welche Zeit passt Ihnen am <strong>{{ availableSlots.selectedDate | formatDate }}</strong> am besten?</p>

                                <div class="row no-gutters">
                                    <div class="col-sm-3" v-for="slot in availableSlots.slots" :key="slot.id" @click="onSelectSlot(slot)">
                                        <div class="booking-slot p-2 mb-2 shadow rounded" v-bind:class="{ active: slotActive(slot.id) }">
                                        <!--<div class="col-sm-9">
                                            <h5 class="text-primary m-0">{{ services[selectedService].name }}</h5>
                                            <p class="small text-muted m-0">Bei: {{ availableSlots.calendars[slot.calendar_id].text }}</p>
                                            <p class="small text-muted m-0">Dauer: {{ services[selectedService].duration }} min</p>
                                            <p class="small text-muted m-0">Datum: {{ slot.start | formatDateTime }}</p> 
                                        </div>
                                        <div class="col align-self-center text-right" v-if="services[selectedService].price !== '0.00'">
                                            <span class="price" v-if="services[selectedService].price">{{ services[selectedService].price }} €</span>
                                        </div>-->
                                        <p class="small m-0 text-center">{{ slot.start | formatTimeSlot }}</p>
                                        </div>
                                    </div>
                                </div>

                                <button class="btn btn-primary my-3 mr-1 float-right" v-if="selectedSlotIds.length" @click="onSlotsSelected()">Weiter</button>

                            </div>

                        </div>

                    </div> <!-- /.slide -->

                    <div class="slide">

                        <div v-if="selectedService && selectedSlots.length">

                            <h5>2. Infos & Kontaktdaten</h5>

                            <div class="review-booking">

                                <div class="booking-data p-2 mb-2 shadow rounded">
                                    <p class="small text-muted m-0">Ihre Auswahl:</p>
                                    <div v-for="selectedSlot in selectedSlots" :key="selectedSlot.id">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <p class="small text-muted m-0">{{ servicesArr[selectedService].name }} | {{ availableSlots.calendarsArr[selectedSlot.calendar_id] }} | Datum: {{ selectedSlot.start | formatDateTime }}</p>
                                            </div>
                                            <!--<div class="col align-self-center text-right" v-if="services[selectedService].price !== '0.00'">
                                                <span class="price">{{ services[selectedService].price }} €</span>
                                            </div>-->
                                        </div>
                                    </div>
                                </div>

                                <!-- Form booking start -->
                                <form class="form-booking" @submit.prevent="onPayNow">

                                    <div class="form-row">

                                        <div class="form-group col-md-6">
                                            <label class="form-label">Vorname:</label>
                                            <input type="text" name="first_name" v-model="formdata.first_name" class="form-control">
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="form-label">Nachname:</label>
                                            <input type="text" name="last_name" v-model="formdata.last_name" class="form-control">
                                        </div>

                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Handynummer:</label>
                                        <input type="text" name="phone" v-model="formdata.phone" class="form-control">
                                        <p class="small text-muted">Bitte angeben für kurzfristige Rückfragen und ggf. SMS Benachrichtungen</p>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Ihre E-Mail Adresse*:</label>
                                        <input type="email" name="email" v-model="formdata.email" class="form-control" required>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Kommentar:</label>
                                        <textarea name="comment" v-model="formdata.comment" :placeholder="comment_placeholder" class="form-control" ></textarea>
                                    </div>

                                    <div class="form-check mb-4">
                                        <input type="checkbox" name="optPrivacy" class="form-check-input" id="optPrivacyCheck" required />
                                        <label class="form-check-label" for="optPrivacyCheck" style="line-height:normal"><small class="text-muted">Mit dem Abschicken des Formulars bestätigen Sie, vorgenannte Informationen und die <a href="https://booklyn.io/datenschutz" target="_blank">Datenschutzhinweise von Booklyn.io</a> zur Kenntnis genommen und akzeptiert zu haben. Sie erklären sich damit einverstanden, dass Ihre personenbezogenen Daten zur Beantwortung Ihrer Anfrage durch uns und unseren Dienstleister verarbeitet werden. Ihre Daten werden nicht kommerziell an Dritte weitergegeben.</small></label>
                                    </div>

                                    <div>
                                        <button class="btn btn-primary btn-lg mb-2">Terminanfrage bestätigen<sup>*</sup></button>
                                        <div v-if="servicesArr[selectedService].accepts_payment_cash"><p class="small text-muted">Der Anbieter stellt als Option <strong>Barzahlung vor Ort</strong> zur Verfügung.</p></div>
                                        <p class="small text-muted"><sup>*</sup> Zahlungen sind auf der nächsten Seite möglich.</p>
                                    </div>

                                    <!--<div v-if="servicesArr[selectedService].accepts_payment_mollie">
                                        <button class="btn btn-primary btn-lg mb-2"><i class="fa fa-lock" aria-hidden="true"></i> Jetzt bezahlen</button>
                                        <p class="small text-muted">Sie werden an unseren Zahlungsdiensleister Mollie weitergeleitet. Nach erfolgreicher Bezahlung haben Sie den Termin gebucht.</p>
                                    </div>-->

                                </form>
                                <!-- Form booking end -->

                            </div>

                        </div>

                    </div>

                </VueSlickCarousel>

            </div> <!-- /.col-sm-12 -->

        </div> <!-- /.row -->
                        
    </div> <!-- /.studio-booking -->

</template>

<script>

    import VueSlickCarousel from 'vue-slick-carousel';
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

    export default {

        components: { VueSlickCarousel },

    	data() {
            return {
                services: [],
                servicesArr: [],
                selectedService: '',
                availableSlots: false,
                selectedSlot: '', // old, TODO check ob noch gebraucht
                selectedSlots: [], // new 06/2021
                selectedSlotIds: [], // new 06/2021
                formdata: { first_name: '', last_name: '', address: '', zip: '', city: '', phone: '', email: '', comment:'' },
                formmeta: { pax: '1' },
                selectedHaendler: [],
                formerrors: {},
                selectedDate: '',
                suggestions: '',
                allTimeSlots: '',
                selectedCalendar: '',
                selectedTimeSlot: {},
                step: 1,
                attrs: [
                    {
                        //key: 'today',
                        //highlight: true,
                        //dates: new Date(),
                    },
                ],
                attributes:
                    {
                        min_date: '',
                        disabled_dates: { weekdays: [1] },
                        available_dates: [ new Date('2021-03-10'), new Date('2021-03-11') ]
                    },
                slicksettings: {
                  arrows: false,
                  dots: false,
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  draggable: false,
                  initialSlide: 0,
                  swipe: false
                },
                comment_placeholder: "" ,
                loading: false,
                error: false
            };
        },

        mounted() {

            this.loading = true;
            this.step = 1;
            var _this = this;
            //this.$refs.carousel.reSlick();

            axios.get('/api/studio/'+this.studioId+'/allservices')
            .then((response) => {
                _this.services = response.data.allServices;
                _this.servicesArr = response.data.allServicesArr;
                _this.$refs.carousel.goTo(0, true);
                _this.step = 1; 
                _this.selectedCalendar = response.data.calendar_ids[0];
                //setTimeout(function(){ _this.$refs.carousel.goToSlide(0); }, 500);
                _this.loading = false;

                console.log(_this.services[0].id);
                _this.selectedService = _this.services[0].id;
                _this.onSelectedService();

            });


            // fix to reset slick slider
            //setTimeout(function(){ this.$refs.carousel.goToSlide(0); }, 800);

        },

        computed: {
        },

        methods: {

            slotActive(slot_id) {
                if(this.selectedSlotIds.indexOf(slot_id) > -1)
                    return true;
                else
                    return false;
            },

            onSelectedService() {

                this.loading = true;

                if(this.selectedService) {
                    var _this = this;
                    axios.get('/api/studio/'+this.studioId+'/get-slots/' + this.selectedService + '?cal='+this.selectedCalendar)
                    .then((response) => {
                        _this.availableSlots = response.data;
                        _this.selectedDate = new Date(response.data.selectedDate);
                        console.log('response.data.availableDates.length');
                        console.log(response.data.availableDates.length);
                        if(response.data.availableDates.length) {
                            var availableDatesArr = [];
                            var availableDates = response.data.availableDates;
                            //console.log(availableDates);
                            for (let key in availableDates) {
                                availableDatesArr.push(new Date((availableDates[key])));
                            }
                            _this.attributes.available_dates = availableDatesArr;
                            _this.loading = false;
                            //_this.$refs.carousel.next();
                            _this.step = 1;
                        }
                        else {
                            _this.error = 'Leider sind für die ausgewählte Leistung aktuell keine Termine verfügbar.';
                            _this.loading = false;
                        }
                    });
                }
                else {
                    this.$refs.carousel.goTo(0, true);
                    this.step = 1; 
                }

            },

            onSelectedCalendar() {
                //console.log(this.selectedCalendar);
                var _this = this;
                _this.loading = true;
                axios.get('/api/studio/'+this.studioId+'/get-slots/' + this.selectedService + '?cal='+this.selectedCalendar)
                .then((response) => {
                    _this.availableSlots = response.data;
                    _this.selectedDate = new Date(response.data.selectedDate);
                    if(response.data.availableDates) {
                        var availableDatesArr = [];
                        var availableDates = response.data.availableDates;
                        //console.log(availableDates);
                        for (let key in availableDates) {
                            availableDatesArr.push(new Date((availableDates[key])));
                        }
                        _this.attributes.available_dates = availableDatesArr;
                        _this.loading = false;
                    }
                    else {
                        _this.loading = false;
                    }
                });
            },

            onStepPrev() {
                this.step = this.step - 1;
                this.$refs.carousel.goTo(this.step - 1);
                if(this.step == 1) {
                    this.selectedService = '';
                }
            },

            onSelectSlot(slot) {                
                const index = this.selectedSlotIds.indexOf(slot.id);
                if(index === -1) {
                    this.selectedSlotIds.push(slot.id);
                    this.selectedSlots.push(slot);
                    console.log("1");
                }
                else { // remove
                    this.selectedSlotIds.splice(index, 1);
                    console.log(slot.id);
                    for (let index = 0; index < this.selectedSlots.length; ++index) {
                        if(this.selectedSlots[index].id == slot.id) {
                            this.selectedSlots.splice(index, 1);
                        }
                    }
                }
            },

            dayClicked(day) {
                //console.log(day);
                var _this = this;
                axios.get('/api/studio/'+this.studioId+'/get-slots/' + this.selectedService + '?d=' + day.id)
                .then((response) => {
                    _this.availableSlots = response.data;
                    _this.selectedDate = new Date(response.data.selectedDate);
                });
            },

            onSlotsSelected() { // last step
                this.$refs.carousel.next();
                this.step = 2;
            },

            onPayNow() {

                this.formerrors = '';
                var _this = this;

                var eventdata = [];
                this.selectedSlots.forEach (function (slot, index) {
                    var event = { start: slot.start, sid: _this.selectedService, cid: slot.calendar_id, ceid: slot.event_id  };
                    eventdata.push( event );
                });

                var data = {
                    formdata: this.formdata,
                    eventdata: eventdata,
                    formmeta: this.formmeta
                }

                console.log(data);

                // create order
                axios.post('/order', data)
                .then((response) => {
                    //console.log(response);
                    if(response.status == 200) {
                        // redirect to mollie if payment is needed
                        //if(_this.servicesArr[_this.selectedService].accepts_payment_mollie)
                            //window.location.href = '/order/' + response.data + '/prepare-payment/';
                        //else
                            window.location.href = '/order/' + response.data + '/confirm';
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        //alert("Leider ging etwas schief.");
                        console.log(error.response.data);
                        _this.formerrors = error.response.data.errors;
                        if(error.response.status == '422') {
                            alert("Bitte prüfen Sie Ihr Formular");
                        }
                        //console.log(error.response.data);
                        //console.log(error.response.headers);
                    }
                });

            },





            checkBooking() {
                var _this = this;
                axios.post('/api/studio/' + this.studioId + '/check', this.$data)
                .then(function (response) {
                    _this.suggestions = response.data.finalSuggestions;
                    _this.allTimeSlots = response.data.allTimeSlots;
                    //_this.selectedDate = response.data[0];
                })
                .catch((error) => {
				    if (error.response) {
                        //alert("Bitte wählen Sie eine Leistung aus");
				        //console.log(error.response.data.errors);
				        //alert(error.response.data.errors);
				        //_this.errors = error.response.data.errors;
				    }
				});
            },

            bookNow() {
                axios.post('/api/studio/' + this.studioId + '/book', this.$data)
                .then(function (response) {
                    if(response.status == 200) {
                        window.location.href = "/booking-request/" + response.data;
                    }
                });
            },

            selectOnce(calendar_id) {
                var currentSelection = this.selectedTimeSlot[calendar_id];
                this.selectedTimeSlot = {};
                this.selectedTimeSlot[calendar_id] = currentSelection;
            },


        },

        props: ['studioId'],

    }
</script>